import styled, { css } from "styled-components"

type SpanIconProps = {
  className?: string
  color: string
  size: number
  block?: boolean
  transform?: {
    x?: string
    y?: string
  }
}

const mixinSpanIconBlock = ({ block }: SpanIconProps) =>
  block &&
  css`
    display: block;
  `

const mixinSpanSize = ({ size }: SpanIconProps) => css`
  box-sizing: content-box !important;
  min-width: ${size}px;
  min-height: ${size}px;
  max-width: auto;
  max-height: ${size}px;
  width: ${size}px;
  height: ${size}px;
  & > svg {
    width: auto;
  }
`

const mixinSpanColor = ({ color }: SpanIconProps) => css`
  /* stylelint-disable-next-line */
  color: ${color};
`

const mixinSpanTransform = ({ transform }: SpanIconProps) =>
  transform &&
  css`
    & > svg {
      transform: translate(${transform.x ?? "0px"}, ${transform.y ?? "0px"});
    }
  `

export const SpanIcon = styled.span<SpanIconProps>`
  ${mixinSpanIconBlock}
  ${mixinSpanSize}
  ${mixinSpanColor}
  ${mixinSpanTransform}
  
  // Fix for icons not aligning properly in their span containers
  & > svg {
    vertical-align: top;
  }

  .svg-icon-paypal {
    display: none;
  }
`
